const LAUNCH_PARAM_KEYS = ["code", "token"];

/**
 * Read TutorCloud → TEMA launch params.
 * Prefer one-time `code` (default TEMA_LAUNCH_MODE=code); fall back to legacy `token`.
 */
export function readLaunchParams() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code")?.trim();
  if (code) {
    return { code };
  }
  const token = params.get("token")?.trim();
  if (!token) {
    return null;
  }
  return {
    token,
  };
}

export function clearLaunchParamsFromUrl() {
  const url = new URL(window.location.href);
  for (const key of LAUNCH_PARAM_KEYS) {
    url.searchParams.delete(key);
  }
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(null, "", next);
}
